export default {"src":"/_next/static/media/icon-enerflo-docflo-document-security-compliance.09725fdb.svg","height":121,"width":121};